module.exports = new __parcel__URL__("favicon-32.cce77696.png").toString();